module.exports = __webpack_public_path__ + "img/图1-10尺寸线.8d35d19f.png";